import { Routes } from '@angular/router'

import { DefaultApplicationPermissionsGuard } from '@flowx/designer/shared/guards/application-permissions.guards'
import { EditProcessInstanceVariablesGuard } from '@flowx/designer/shared/guards/workspaces-permissions.guards'
import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

import { ProcessInstancePageComponent } from './pages/process-running-instance/process-running-instance.page'

export const RuntimeProcessInstanceRoutes: Routes = [
  {
    path: ':selectedProcessResourceId/instance',
    component: ProcessInstancePageComponent,
    canActivate: [
      DefaultApplicationPermissionsGuard('process_instances_read'),
      EditProcessInstanceVariablesGuard(),
    ],
    data: {
      [LayoutOptions.HAS_TOP_BANNER]: false,
      [LayoutOptions.IS_RUNNING_INSTANCE]: true,
    },
    children: [
      {
        path: 'workflow-instances',
        loadChildren: () =>
          import(
            '@flowx/designer/modules/integration-designer/workflow-integration/workflow-instances-routes'
          ).then((m) => m.workflowInstancesRoutes),
        outlet: 'workflowInstances',
      },
    ],
  },
]
